//Get the scrollbar width
let r = document.querySelector(':root');
let scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';

r.style.setProperty('--scrollbar-width', scrollbarWidth);

// Menu trigger
let header = document.querySelector('#site-header');

// Get scroll Y of element
function getOffset(el) {
	const rect = el.getBoundingClientRect();
	return {
		left: rect.left + window.scrollX,
		top: rect.top + window.scrollY
	};
}

const afterHero = document.querySelector("main.primary > section:nth-child(1)"); // First section after hero
let navOffset = 0

if (afterHero) {
	navOffset = (getOffset(afterHero).top-70);
}

function homeHeaderScroll() {
	if (document.body.scrollTop > navOffset || document.documentElement.scrollTop > navOffset) {
		header.classList.add('visible');
	} else {
		header.classList.remove('visible');
	}
}

if (document.querySelector('.page-home')) {
	window.addEventListener("scroll", homeHeaderScroll);
}

// Prevent anchor tags from showing in URL
let anchorLinks = document.querySelectorAll("a[href^=\'#\'] ");

anchorLinks.forEach(anchor => {
	anchor.addEventListener("click", function(event){
		setTimeout(() => {
			history.replaceState(null, null, ' ');
		}, 5);
	});
});
